export const footerMoreLinks = {
  'ge-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://ge.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://ge.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://ge.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://ge.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://ge.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://ge.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'ge-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://ge.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ge.wingie.com/en/faq/',
          title: 'FAQ',
        },
        {
          href: 'https://ge.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://ge.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://ge.wingie.com/en/terms-and-conditions/',
          title: 'Terms and conditions',
        },
        {
          href: 'https://ge.wingie.com/en/awards/',
          title: 'Our awards',
        },
      ],
    },
  ],
  'ge-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://ge.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://ge.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://ge.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://ge.wingie.com/ar/privacy/',
          title: 'الخصوصية',
        },
        {
          href: 'https://ge.wingie.com/ar/terms-and-conditions/',
          title: 'الشروط والأحكام',
        },
        {
          href: 'https://ge.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'ge-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://ge.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://ge.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen',
        },
        {
          href: 'https://ge.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://ge.wingie.com/de/datenschutz/',
          title: 'Datenschutz',
        },
        {
          href: 'https://ge.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://ge.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'ge-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://ge.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://ge.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas frecuentes',
        },
        {
          href: 'https://ge.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://ge.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://ge.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones',
        },
        {
          href: 'https://ge.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'ge-it': [
    {
      title: 'Di più',
      items: [
        {
          href: 'https://ge.wingie.com/it/contact/',
          title: 'Contatto',
        },
        {
          href: 'https://ge.wingie.com/it/faq/',
          title: 'Domande frequenti',
        },
        {
          href: 'https://ge.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://ge.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://ge.wingie.com/it/terms-and-conditions/',
          title: 'Termini e condizioni',
        },
        {
          href: 'https://ge.wingie.com/it/awards/',
          title: 'I nostri premi',
        },
      ],
    },
  ],
  'ge-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://ge.wingie.com/fr/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ge.wingie.com/fr/faq/',
          title: 'Questions fréquentes',
        },
        {
          href: 'https://ge.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://ge.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://ge.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et conditions',
        },
        {
          href: 'https://ge.wingie.com/fr/awards/',
          title: 'Nos récompenses',
        },
      ],
    },
  ],
  'ge-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://ge.wingie.com/pt/contact/',
          title: 'Contacto',
        },
        {
          href: 'https://ge.wingie.com/pt/faq/',
          title: 'Perguntas frequentes',
        },
        {
          href: 'https://ge.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://ge.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://ge.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e condições',
        },
        {
          href: 'https://ge.wingie.com/pt/awards/',
          title: 'Nossos prêmios',
        },
      ],
    },
  ],
  'ge-ro': [
    {
      title: 'Mai multe',
      items: [
        {
          href: 'https://ge.wingie.com/ro/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ge.wingie.com/ro/faq/',
          title: 'Întrebări frecvente',
        },
        {
          href: 'https://ge.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://ge.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://ge.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și condiții',
        },
        {
          href: 'https://ge.wingie.com/ro/awards/',
          title: 'Premiile noastre',
        },
      ],
    },
  ],
  'ge-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://ge.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        {
          href: 'https://ge.wingie.com/pl/faq/',
          title: 'Często zadawane pytania',
        },
        {
          href: 'https://ge.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://ge.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://ge.wingie.com/pl/terms-and-conditions/',
          title: 'Warunki i zasady',
        },
        {
          href: 'https://ge.wingie.com/pl/awards/',
          title: 'Nasze nagrody',
        },
      ],
    },
  ],
  'ge-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://ge.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        {
          href: 'https://ge.wingie.com/lt/faq/',
          title: 'Dažniausiai užduodami klausimai',
        },
        {
          href: 'https://ge.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://ge.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://ge.wingie.com/lt/terms-and-conditions/',
          title: 'Sąlygos ir nuostatos',
        },
        {
          href: 'https://ge.wingie.com/lt/awards/',
          title: 'Mūsų apdovanojimai',
        },
      ],
    },
  ],
  'ge-uz': [
    {
      title: 'Boshqa',
      items: [
        {
          href: 'https://ge.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        {
          href: 'https://ge.wingie.com/uz/faq/',
          title: "Tez-tez so'raladigan savollar",
        },
        {
          href: 'https://ge.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://ge.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://ge.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va qoidalar',
        },
        {
          href: 'https://ge.wingie.com/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'ge-sr': [
    {
      title: 'Više',
      items: [
        {
          href: 'https://ge.wingie.com/sr/contact/',
          title: 'Kontakt',
        },
        {
          href: 'https://ge.wingie.com/sr/faq/',
          title: 'Često postavljana pitanja',
        },
        {
          href: 'https://ge.wingie.com/sr/about-us/',
          title: 'O nama',
        },
        {
          href: 'https://ge.wingie.com/sr/privacy/',
          title: 'Privatnost',
        },
        {
          href: 'https://ge.wingie.com/sr/terms-and-conditions/',
          title: 'Uslovi i odredbe',
        },
        {
          href: 'https://ge.wingie.com/sr/awards/',
          title: 'Naše nagrade',
        },
      ],
    },
  ],
  'ge-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://ge.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        {
          href: 'https://ge.wingie.com/ky/faq/',
          title: 'Көп берилүүчү суроолор',
        },
        {
          href: 'https://ge.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://ge.wingie.com/ky/privacy/',
          title: 'Купуялуулук',
        },
        {
          href: 'https://ge.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана эрежелер',
        },
        {
          href: 'https://ge.wingie.com/ky/awards/',
          title: 'Биздин сыйлыктар',
        },
      ],
    },
  ],
  'ge-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://ge.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        {
          href: 'https://ge.wingie.com/tg/faq/',
          title: 'Саволҳои зиёд пурсида шаванда',
        },
        {
          href: 'https://ge.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://ge.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://ge.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва қоидаҳо',
        },
        {
          href: 'https://ge.wingie.com/tg/awards/',
          title: 'Ҷоизаҳои мо',
        },
      ],
    },
  ],
  'ge-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://ge.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        {
          href: 'https://ge.wingie.com/kk/faq/',
          title: 'Жиі қойылатын сұрақтар',
        },
        {
          href: 'https://ge.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://ge.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://ge.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://ge.wingie.com/kk/awards/',
          title: 'Біздің сыйлықтарымыз',
        },
      ],
    },
  ],
  'ge-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://ge.wingie.com/nl/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ge.wingie.com/nl/faq/',
          title: 'Veelgestelde vragen',
        },
        {
          href: 'https://ge.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://ge.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://ge.wingie.com/nl/terms-and-conditions/',
          title: 'Algemene voorwaarden',
        },
        {
          href: 'https://ge.wingie.com/nl/awards/',
          title: 'Onze awards',
        },
      ],
    },
  ],
  'ge-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://ge.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://ge.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://ge.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://ge.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://ge.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://ge.wingie.com/ja/awards/' },
      ],
    },
  ],
  'ge-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://ge.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://ge.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://ge.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://ge.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://ge.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://ge.wingie.com/zh/awards/' },
      ],
    },
  ],
  'ge-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://ge.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://ge.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://ge.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://ge.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://ge.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://ge.wingie.com/ko/awards/' },
      ],
    },
  ],
  'ge-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://ge.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://ge.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://ge.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://ge.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://ge.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://ge.wingie.com/hi/awards/' },
      ],
    },
  ],
  'ge-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://ge.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://ge.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://ge.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://ge.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://ge.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://ge.wingie.com/ta/awards/' },
      ],
    },
  ],
  'ge-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://ge.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://ge.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://ge.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://ge.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://ge.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://ge.wingie.com/th/awards/' },
      ],
    },
  ],
  'ge-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://ge.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://ge.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://ge.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://ge.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://ge.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://ge.wingie.com/ur/awards/' },
      ],
    },
  ],
  'ge-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://ge.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://ge.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://ge.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://ge.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://ge.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://ge.wingie.com/ka/awards/' },
      ],
    },
  ],
}
